class FP_Utils {
	/**
	 * Detect when the document is ready even if the script is loaded async/defer
	 *
	 * @param {object} callback  The function to execute when the document is ready
	 */
	static onReady(callback) {
		if (document.readyState != 'loading') {
			callback();
			return;
		}
		
		document.addEventListener('DOMContentLoaded', callback);
	}
}